import { ReconBankPoolAddPage } from "@/features/recon-bank/pages/ReconBankPoolAddPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-bank-upload/add")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ReconBankPoolAddPage,
});
